import React, { useState, useEffect } from 'react';
import { connect} from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { MOBILE_STORES } from '../../app/common/mobile-stores';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import * as actionsAuth  from '../../app/actions/auth/auth';
//import InsCompLogos from './components/svg/insCompLogos';
import InsCompLogosZoom from './components/svg/insCompLogosZoom';
import NewsMain from './components/adminModule/NewsMain';

const insCompanies = ["bulins", "bulstrad", "dzi", "euroins", "generali", "uniqa",
                      "levins", "groupama", "dallbogg", "ozkins", "allianz", "armeetz"];
const insCompanies2 = ["bulins", "bulstrad", "dzi", "euroins", "generali", "uniqa",
                        "levins", "groupama",  "dallbogg", "ozkins", "allianz", "armeetz"];
const insCompanies3 = ["bulins", "bulstrad", "dzi", "euroins", "generali", "uniqa",
                      "levins", "groupama", "dallbogg", "ozkins", "allianz", "armeetz"];

const Home = () => {
  //const [playstore] = useState(MOBILE_STORES.playStoreUrl)
  //const [appstore] = useState(MOBILE_STORES.appStoreUrl)
  //const [gallery] = useState(MOBILE_STORES.appGalleryUrl)
  const [videoBox,setVideoBox] = useState(false)
  const [prototypeBox1,setPrototypeBox1] = useState(false)
  const [prototypeBox2,setPrototypeBox2] = useState(false)

  const toggleVideoBox = () => {
    setVideoBox(!videoBox)
  }

  const togglePrototypeBox1 = () => {
    setPrototypeBox1(!prototypeBox1)
  }

  const togglePrototypeBox2 = () => {
    setPrototypeBox2(!prototypeBox2)
  }

  const updateOnScroll = () => {
    var demoSection = $('.demo-section');
    var propsSection = $('.props-section');
    var props2Section = $('.props2-section');
    var featureSection = $('.feature-section');
    var messageSection = $('.message-section');
    var aboutSection = $('.about-section');

    var demoSectionPosition = demoSection.position().top;
    var aboutSectionPosition = aboutSection.position().top;

    var demoSectionCalculation = demoSectionPosition + demoSection.height() + propsSection.height() + featureSection.height() + props2Section.height() + messageSection.height();
    var aboutSectionCalculation = aboutSectionPosition + aboutSection.height();

    if (($(this).scrollTop() > (demoSectionPosition - 250)) && ($(this).scrollTop() < (demoSectionCalculation + 250))) {
      $('.menuLink').each(function () {
        $(this).removeClass('active');
      });

      $('.our-app').addClass('active');
    } else if (($(this).scrollTop() > (aboutSectionPosition - 250)) && ($(this).scrollTop() < (aboutSectionCalculation + 100))) {
      $('.menuLink').each(function () {
        $(this).removeClass('active');
      });

      $('.about-us').addClass('active');
    } else {
      $('.menuLink').each(function () {
        $(this).removeClass('active');
      });
    }

  };
  
  // component on init run callbackfunction
  useEffect( () => {

    $('.open-video, .open-prototype').on('click', function () {
      $('body').toggleClass('scroll-off');
    });

    $('.close').on('click', function () {
      $('body').removeClass('scroll-off');
    });     

    //updateOnScroll();


  }, []);

  const renderComponiesLogosFirst = (insCompanies, index1, index2) => {
      const companies = insCompanies.slice(index1, index2);
      return companies.map((company, i) =>  {
       // const classes_one =  'groupama_ozkins_generali_uniqa_allianz'.includes(company) ? 'shift-logo' : '';
       // const classes_two =  'euroins_uniqa'.includes(company) ? 'shift-logo-two' : '';
       // const classes_three =  'groupama_ozkins'.includes(company) ? 'shift-logo-three' : '';
       // const CompanyLogo   = InsCompLogos[company] ? InsCompLogos[company]() : null;
        const CompanyLogo   = InsCompLogosZoom()[company] ? InsCompLogosZoom()[company]() : null;
       // return ( <div className={`${classes_one} ${classes_two}  ${classes_three}`} key={i+1}>{CompanyLogo}</div> )
        return ( <div key={i+1}>{CompanyLogo}</div> )
      });
  }

  return ( 
    <div onScroll={updateOnScroll}>
    <Helmet>
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
    </Helmet>

      {/* section new    */}
      <section className="landing-offers">
        <div className="container-main">
            <div className="landing-left-container">
                <div className="landing-left-inner">
                    <div className="left-inner-two">
                        <div className="image">
                            <Link to="/"  onClick={togglePrototypeBox1} className="open-prototype">
                                <img src="img/mockup-device-1.png" alt="Купи и поднови гражданска отговорност – онлайн." />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="landing-right-container">
                <div className="landing-right-inner">
                    <br />
                    <h1 className="landing-right-header">ГРАЖДАНСКА ОТГОВОРНОСТ</h1>
                    <h2  className='landing-right-main-h'>
                        <span className="landing-right-text-main">ТИ ИЗБИРАШ</span>
                        <span className="landing-right-text">ЦЕНА и ЗАСТРАХОВАТЕЛ</span>
                    </h2 >
                    <Link to="/app/new-policy-liability" className="nuIns-btn nuIns-btn-landing">СРАВНИ ЦЕНИТЕ и КУПИ ОНЛАЙН</Link>
                </div>
            </div>
        
        </div>       
      </section>

        <section className='mobile-stores'>
            <div className='row-one'>
                <figure className="google-play">
                    <a href={MOBILE_STORES.playStoreUrl} title="Свали от Google Play">
                        <img src="/img/download-google-play.png" alt="Nu INS app in Google Play" ></img>
                    </a>
                </figure>
                <figure className="app-store">
                    <a href={MOBILE_STORES.appStoreUrl} title="Свали от App Store">
                        <img src="/img/download-app-store.png" alt="Nu INS app in App Store" ></img>
                    </a>
                </figure>
            </div>
            <div className='row-two'>
                <figure className="app-gallery">
                    <a href={MOBILE_STORES.appGalleryUrl} title="Свали от App Gallery">
                        <img src="/img/download-huawei.png" alt="Nu INS app in App Gallery" ></img>
                    </a>
                </figure>
            </div>
        </section>
{/*
        <section className='mobile-stores-tablet'>
            <div className='row-one'>
                <figure className="google-play">
                    <a href={MOBILE_STORES.playStoreUrl} title="Свали от Google Play">
                        <img src="/img/download-google-play.png" alt="Nu INS app in Google Play" ></img>
                    </a>
                </figure>
                <figure className="app-store">
                    <a href={MOBILE_STORES.appStoreUrl} title="Свали от App Store">
                        <img src="/img/download-app-store.png" alt="Nu INS app in App Store" ></img>
                    </a>
                </figure>
                <figure className="app-gallery">
                    <a href={MOBILE_STORES.appGalleryUrl} title="Свали от App Gallery">
                        <img src="/img/download-huawei.png" alt="Nu INS app in App Gallery" ></img>
                    </a>
                </figure>
            </div>
        </section>
*/}
      <section className='ins-companies'>
        <div className="container-main">
            <div className='left'></div>
            <div className='right'>
                <div className="common-row">{renderComponiesLogosFirst(insCompanies, 0)}</div>
                <div className="common-row-2">{renderComponiesLogosFirst(insCompanies2, 0)}</div>
                <div className="common-row-3">{renderComponiesLogosFirst(insCompanies3, 0)}</div>
                
            </div>
        </div>
      </section>
      <section>
       
            <div className='video-box-one'>
                <div className="video">
                
                    <div className="holder">
                        <div className="block">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/YGAwGk_5Q8Y" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="videoBox" allowFullScreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
  
      </section>

     

     {/* section two */}
     <section className="feature left demo-section">
        <div className="anchor" id="demo"></div>
        <div className="container-main">
            <div className="content">
                <h4>Сигурното и надеждно мобилно приложение NuIns</h4>
                <h3>Най-изгодният път за евтина гражданска отговорност за всеки автомобил</h3>
                <p>Nu INS ти дава всички изгодни предложения, специално калкулирани за Вашите нужди.</p>
            </div>
            <div className="image">
                <Link to="/"  onClick={togglePrototypeBox1} className="open-prototype">
                                                            
                    <img src="img/mockup-device-1.png" alt="iPhone XS Max" />
                </Link>
            </div>
        </div>
    </section>

    {/* section News */}
    <section className="message message-section">
    <div className="anchor" id="news"></div>
        <div className="container-main">
            <div className="container-news">
                <NewsMain />
            </div>
        </div>
    </section>

    {/* section three */}
    <section className="props props-section">
        <div className="container-main">
            <div className="list">
                <div className="item">
                    <figure className="image big">
                        <img src="/img/props-1.png" alt="" />
                    </figure>
                    <h3>Специални оферти за твоя автомобил директно от Застрахователя</h3>
                    <p>Офертите са генерирани за твоя автомобил, тъй като информацията за него се получава чрез номера на талона. Така няма да попълваш данни до безкрай.</p>
                </div>
                <div className="item">
                    <figure className="image big">
                        <img src="/img/props-2.png" alt="" />
                    </figure>
                    <h3>Получаваш полицата с безплатна доставка до твоя дом или офис</h3>
                    <p>При сключване на нова застраховка “Гражданска Отговорност” ние поемаме доставката.</p>
                </div>
                <div className="item">
                    <figure className="image big">
                        <img src="/img/props-3.png" alt="" />
                    </figure>
                    <h3>Ние ще се погрижим да ти напомним в точния момент</h3>
                    <p>Никога повече няма да останеш без валидна застраховка. Ще получиш напомняне за подновяване и/или за предстояща вноска.</p>
                </div>
            </div>
        </div>
    </section>

    {/* section four */}
    <section className="feature right feature-section">
        <div className="container-main">
            <div className="content">
                <h4>Сигурното и надеждно мобилно приложение NuIns</h4>
                <h3 className="big">Напомняне винаги в точния момент</h3>
                <p>С Nu INS ще имаш винаги валидна застраховка. Ние ще се погрижим да ти напомним за предстояща вноска или за подновяване на полицата, ако тя изтича.</p>
            </div>
            <div className="image">
                <Link to="/" onClick={togglePrototypeBox2} className="open-prototype">
                               
                    <img src="/img/mockup-device-2.png" alt="iPhone XS Max" />
                </Link>
            </div>
        </div>
    </section>

    <section className="message message-section">
        <div className="container-main">
            <div className="description">
                <figure className="logo">
                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                </figure>
                <h3>Застраховай се в движение</h3>
                <p>Представи си всички твои застраховки в едно приложение. В момента можеш да сключиш застраховка “Гражданска отговорност”. Очаквай скоро и други видове застраховки в приложението.</p>
            </div>
        </div>
    </section>

    <section className="props props2-section">
        <div className="container-main">
            <div className="list">
                <div className="item">
                    <figure className="image small">
                        <img src="/img/props-4.png" alt="" />
                    </figure>
                    <h3>Прозрачност</h3>
                    <p>Без скрити такси и клаузи. Ако имаш въпроси относно застраховката ти, ще намериш отговор в Nu INS.</p>
                </div>
                <div className="item">
                    <figure className="image small">
                        <img src="/img/props-5.png" alt="" />
                    </figure>
                    <h3>Доверие</h3>
                    <p>Довери се на дългогодишния опит в застраховането в комбинация с развитието на технологиите.</p>
                </div>
                <div className="item">
                    <figure className="image small">
                        <img src="/img/props-6.png" alt="" />
                    </figure>
                    <h3>Свобода</h3>
                    <p>Бързо и лесно имаш свободата да се застраховаш от всяка точка във всеки момент с приложението Nu INS.</p>
                </div>
            </div>
        </div>
    </section>

    {/* section five */}
    <section className="message about-section">
    <div className="anchor" id="about"></div>
    <div className="container-main">
        <div className="description">
            <h3>За нас</h3>
            <p>Ние вярваме, че имаш правото да се застраховаш с лекота. Затова създадохме Nu INS - приложението, което прави застраховането лесно, достъпно и прозрачно за теб. В стремеж към коренна промяна, въз основа на опита в застраховането, комбиниран
                с опита в развитието на иновативни технологични продукти, направихме процеса на сключване на застраховка максимално кратък за теб.</p>   
        </div>
        <div className='link-to'>
            <Link to="/team" className="">
                <span>Научи повече за нашия екип &rarr;</span>
            </Link>
        </div>

        {/*
        <div className="list">
            <div className="item left">
                <div className="image">
              
                        <img src="/img/team/nikoleta-aleksieva.png" alt="Николета Алексиева" />
               
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Николета Алексиева</h2>
                    <h3>Изпълнителен Директор</h3>
                    <p>От идеята, носеща разрешение на конкретен проблем на пазара, през оперативните процеси, поставени в законодателната рамка за извършване на дейността, привличането на таланти в организацията и мотивацията им за постигане на корпоративните цели чрез осъществяването на личните им кариерни планове, до заслужено доверие от страна на клиентите. 
                        Това е двигателя към успеха за развитието на едно софтуерно решение в бизнес, генериращ стойност за потребителите, създателите и общността.</p>
                </div>
            </div>
            <div className="item right">
                <div className="image">
         
                        <img src="/img/team/pavel-panayotov.png" alt="Павел Панайотов" />
              
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Павел Панайотов</h2>
                    <h3>Директор Бизнес Развитие</h3>
                    <p>Професионалист с четвърт век опит в бизнес развитието и управлението на продажби, извървял пътя от стартиращ предприемач, през ръководител на стратегически телекомуникационни проекти до директор на няколко застрахователни и пенсионно-осигурителни дружества. За него, Nu INS е поглед в бъдещето и неизбежна крачка от еволюцията на застрахователния бизнес!</p>
                </div>
            </div>

            <div className="item left">
                <div className="image">
         
                        <img src="/img/team/desislava-lazarova.jpg" alt="Десислава Лазарова" />
           
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Десислава Лазарова</h2>
                    <h3>Директор Операции</h3>
                    <p>Експерт с богат и разнообразен опит в застраховането и човек с изключителен поглед върху детайла, умеещ да подреди еквилибриума от застрахователни рискове и най-подходящи за клиента покрития, превеждайки му с лекота застрахователната материя на на човешки език. 
                        Убедено вярва, че Nu INS e крачка към свободата, клиентът да избира кога, къде и какво да застрахова!</p>
                </div>
            </div>
            <div className="item right">
                <div className="image">
                    <figure>
                        <img src="/img/team/svetoslav-moldovanski.jpg" alt="Светослав Молдовански" />
                    </figure>
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Светослав Молдовански</h2>
                    <h3>Основател, IT Manager</h3>
                    <p>Светослав е двигател на техническия екип, пренася своя дългогодишен опит в дигиталната трансформация на банкови услуги в застрахователната индустрия, за да превърне Nu INS в иновативно решение, което дава сигурност, свобода и индивидуално
                        изживяване на клиента.</p>
                </div>
            </div>
            <div className="item left">
                <div className="image">
                    <figure>
                        <img src="/img/team/peter-aleksiev.jpg" alt="Петър Алексиев" />
                    </figure>
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Петър Алексиев</h2>
                    <h3>Финансов Мениджър</h3>
                    <p>Петър внася в Nu INS своя ентусиазъм за бъдещето на мобилните технологии във всички сфери на бизнеса. Той има богат и разнообразен опит в областта на финансите, натрупан в седем страни на три континента.</p>
                </div>
            </div>
          
            <div className="item right">
                <div className="image">
                    <figure>
                        <img src="/img/team/mariana-ivanova.jpg" alt="Мариана Иванова" />
                    </figure>
                </div>
                <div className="content">
                    <figure>
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Мариана Иванова</h2>
                    <h3>UX Дизайнер</h3>
                    <p>След 8 години опит в създаването на корпоративни приложения, страстта на Мариана, продължава да бъде процесът на разбиране и учене, тъй като вярва, че във всяко взаимодействие между клиента и продукта съществува път на обучение. Затова
                        нейната цел е да елиминира объркването на потребителя и да създаде пълноценно и приятно изживяване за клиентите на Nu INS.</p>
                </div>
            </div>
        </div>
        */}
    </div>
</section>

<section className="partners">
    <div className="container-main">
       


        <div className="wrapper">
            <h4>Инвеститор в Дружеството е „Иновейшън Кепитъл Фонд“ КДА, чиято дейност се изпълнява със съфинансиране от Европейския фонд за регионално развитие по Оперативна програма „Иновации и конкурентоспособност“ 2014-2020, управлявано от Фонд на фондовете в България.</h4>
            <div className="list">
                <div className="item investors-logos">
                    <Link to="/" >
                        <img src="/img/investors/Innovation_Capital.png" alt="Иновейшън капитал" />
                    </Link>
                </div>
                <div className="item investors-logos">
                    <Link to="/" >
                        <img src="/img/investors/fof-bg.png" alt="Фонд на фондовете" />
                    </Link>
                </div>
                <div className="item investors-logos">
                    <Link  to="/" >
                        <img src="/img/investors/bg-center.jpg" alt="Иновации и конкурентноспособност" />
                    </Link>
                </div>
                <div className="item investors-logos">
                    <Link to="/" >
                        <img src="/img/investors/ec-bg.jpg" alt="Европейски съюз" />
                    </Link>
                </div>               
            </div>
        </div>
    </div>
    </section>

    {/* section six */}
    <div className={"video-box " + ( videoBox ? 'show-main' : 'hide') } >
        <div className="header">
        <div className="wrapper">
            <figure className="logo">
                <img src="/img/logo-dark.png" alt="Nu INS logo" />
            </figure>
            <span className="close" onClick={toggleVideoBox} ></span>
           
        </div>
    </div>
    <div className="video">
        <span className="close" onClick={toggleVideoBox}></span>
       
        <div className="holder">
            <div className="block">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/YGAwGk_5Q8Y" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="videoBox" allowFullScreen></iframe>
            </div>
        </div>
    </div>
</div>

<div className={"prototype-box " + ( prototypeBox1 ? 'show1' : 'hide1')}>
    <span className="close" onClick={togglePrototypeBox1} ></span>

    <iframe width="560" height="315" src="/screens/prototype1/index.html" frameBorder="0" title="prototypeBox1"></iframe>
</div>

<div className={"prototype-box " + ( prototypeBox2 ? 'show2' : 'hide2')} >
    <span className="close" onClick={togglePrototypeBox2}>
     
    </span>
    <iframe width="560" height="315" src="/screens/prototype2/index.html" frameBorder="0" title="prototypeBox2"></iframe>
</div>


    </div>
  );
}

export default connect(null, {...actionsAuth})(Home);



/*
<section className="landing-offers">
<div className="container-main">
    <div className="landing-left-container">
        <h4 className="landing-left-header">НОВО</h4>
        <div className="landing-left-inner">
            <h4 className="landing-left-text">ПЛАТИ ВНОСКА ПО ГРАЖДАНСКА</h4>
            <div className="left-inner-two">
                <div>
                    <h4 className="landing-left-text">КУПИ ВИНЕТКА</h4>
                    <div className="left-inner-two_logo">
                        <h4 className="landing-left-text">С</h4>
                        <img src="img/logo-dark.png" alt="iPhone XS Max" />
                    </div>
                </div>
                <div className="image">
                    <img src="img/mockup-device-3.png" alt="iPhone XS Max" />
                </div>
            </div>
        </div>

    </div>
    <div className="landing-right-container">
        <div className="landing-right-inner">
            <br />
            <h3 className="landing-right-header">ГРАЖДАНСКА ОТГОВОРНОСТ</h3>
            <h4 className="landing-right-text">ИЗБЕРИ <span style={{fontWeight: '600'}}>НАЙ ДОБРАТА ОФЕРТА</span></h4>
            <h4 className="landing-right-text">ЗА ТВОЯ АВТОМОБИЛ</h4>
            <Link to="/app/new-policy-liability" className="nuIns-btn nuIns-btn-landing">СРАВНИ ЦЕНИТЕ</Link>
        </div>
        <div className="ins-companies">
            <div className="ins-companies_first">{renderComponiesLogosFirst(0, 6)}</div>
            <div className="ins-companies_second">{renderComponiesLogosFirst(6)}</div>
        </div>
    </div>
</div>
</section>


   <section className="message message-section">
            <div className="container-main">
                <div className="description">
                    <figure className="logo">
                        <img src="/img/logo-dark.png" alt="Nu INS logo" />
                    </figure>
                    <h2>Застраховай се в движение</h2>
                    <p>Представи си всички твои застраховки в едно приложение. В момента можеш да сключиш застраховка “Гражданска отговорност”. Очаквай скоро и други видове застраховки в приложението.</p>
                </div>
            </div>
      </section>

      --- section one  ---
      <section className="call-to-action" id="maintarget">
        <div className="container-main">
            <div className="details">
                <h1>Застраховай се в движение</h1>
                <p>Представи си, че можеш да сключиш твоята застраховка “Гражданска Отговорност” бързо и лесно във всеки момент, независимо къде се намираш. Приложението Nu INS e тук, за да те улесни в света на застраховките.</p>
                <ul className="download-buttons">
                    <li>
                        <figure className="google-play">
                            <a href={playstore} title="Свали от Google Play">
                                <img src="/img/download-google-play.png" alt="Nu INS app in Google Play"/>
                            </a>
                        </figure>
                    </li>
                    <li>
                        <figure className="app-store">
                            <a href={appstore} title="Свали от App Store">
                                <img src="/img/download-app-store.png" alt="Nu INS app in App Store" />
                            </a>
                        </figure>
                    </li>
                    <li>
                        <figure className="app-gallery">
                            <a href={gallery} title="Свали от App Gallery">
                                <img src="/img/download-huawei.png" alt="Nu INS app in App Gallery" />
                            </a>
                        </figure>
                    </li>
                </ul>
            </div>
            <div className="video">
                <figure className="video-play">
                    <Link to="/" onClick={toggleVideoBox} className="open-video">  
                                                                        
                        <img src="/img/cta-video.png" alt="Video play" />
                    </Link>
                </figure>
            </div>
        </div>
        <div className="background"></div>
     </section>


<div className="first-row">{renderComponiesLogosFirst(0, 5)}</div>
                <div className="second-row">{renderComponiesLogosFirst(5)}</div>


*/
/*
<div className="wrapper">
<h3>С Nu INS можеш да си купиш застраховка “Гражданска Отговорност” от нашите партньори</h3>
<div className="list">
    <div className="item">
        <Link  to="/">
            <img src="/img/partners/bulins.png" alt="Бул Инс" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/bulstrad.png" alt="Булстрад" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/groupama.png" alt="Групама" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/generali.png" alt="Generali" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/dzi.png" alt="ДЗИ" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/euroins.png" alt="Евроинс АД" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/levins.png" alt="Лев Инс" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/ozk.png" alt="ЗАД “ОЗК-Застраховане”" />
        </Link>
    </div>
    <div className="item">
        <Link to="/">
            <img src="/img/partners/uniqa.png" alt="Уника" />
        </Link>
    </div>
</div>
</div>
        <div className="wrapper">
            <h3>Други партньори</h3>
            <div className="list">
                <div className="item">
                    <Link to="/">
                        <img src="/img/partners/allianz.png" alt="Алианц" />
                    </Link>
                </div>
                <div className="item">
                    <Link to="/">
                        <img src="/img/partners/armeec.png" alt="Армеец" />
                    </Link>
                </div>
            </div>
        </div>
*/